import { motion } from "framer-motion";
import { WHY_US } from "@/lib/site";
import { Reveal, SectionLabel } from "@/components/primitives";

export default function WhyUs() {
  return (
    <section id="why-us" className="relative overflow-hidden py-20 sm:py-28 lg:py-32" data-testid="why-us-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          {/* Left heading */}
          <Reveal>
            <SectionLabel color="#65A30D">Why Digital Advyzer</SectionLabel>
            <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-[#111827] sm:text-5xl lg:text-6xl">
              Small scope.
              <br />
              <span className="text-gradient-warm">Big impact.</span>
            </h2>
            <p className="mt-5 max-w-sm text-base text-slate-600">
              We intentionally focus on only three services — so every project gets our full craft
              instead of a watered-down checklist.
            </p>
            <div className="relative mt-10 hidden h-40 lg:block">
              <div className="absolute left-0 top-0 h-28 w-28 rounded-full bg-[#FF6B35]/15" />
              <div className="absolute left-16 top-10 h-20 w-20 rounded-[1.5rem] bg-[#2563EB]/15 rotate-12" />
              <div className="absolute left-36 top-4 h-16 w-16 rounded-full border-4 border-[#B7F34A]" />
            </div>
          </Reveal>

          {/* Right blocks */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {WHY_US.map((item, i) => (
              <Reveal key={item.num} delay={i * 0.08}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 260, damping: 20 }}
                  className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-white p-6 shadow-card ring-1 ring-slate-100 sm:p-7"
                  data-testid={`why-us-card-${item.num}`}
                >
                  <span
                    className="pointer-events-none absolute -right-6 -top-6 font-display text-8xl font-extrabold opacity-[0.07] transition-opacity group-hover:opacity-[0.12]"
                    style={{ color: item.color }}
                  >
                    {item.num}
                  </span>
                  <span className="h-10 w-10 rounded-xl" style={{ background: `${item.color}1a` }}>
                    <span className="flex h-full w-full items-center justify-center font-display text-sm font-bold" style={{ color: item.color }}>
                      {item.num}
                    </span>
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold text-[#111827]">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.desc}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
